// Frontend copy of the MP district list — mirrors /app/backend/masters.py.
// Kept in sync manually (small, stable set); used by the government District
// Credit Map heatmap to show all 55 districts even when demand is zero.
export const MP_DISTRICTS = [
  "Agar Malwa", "Alirajpur", "Anuppur", "Ashoknagar", "Balaghat", "Barwani",
  "Betul", "Bhind", "Bhopal", "Burhanpur", "Chhatarpur", "Chhindwara", "Damoh",
  "Datia", "Dewas", "Dhar", "Dindori", "Guna", "Gwalior", "Harda", "Indore",
  "Jabalpur", "Jhabua", "Katni", "Khandwa", "Khargone", "Maihar", "Mandla",
  "Mandsaur", "Mauganj", "Morena", "Narmadapuram", "Narsinghpur", "Neemuch",
  "Niwari", "Pandhurna", "Panna", "Raisen", "Rajgarh", "Ratlam", "Rewa", "Sagar",
  "Satna", "Sehore", "Seoni", "Shahdol", "Shajapur", "Sheopur", "Shivpuri",
  "Sidhi", "Singrauli", "Tikamgarh", "Ujjain", "Umaria", "Vidisha",
];
